import * as yup from 'yup';

const optionalNumber = () => yup
  .number()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue === null || originalValue === undefined) {
      return null;
    }
    return value;
  })
  .nullable();

const validateGameExists = (value: unknown, context: any) => {
  const gamesData = context?.gamesData as Map<string, number> | null | undefined;
  if (!gamesData || gamesData.size === 0) {
    return true;
  }

  if (value === null || value === undefined) {
    return true;
  }

  return gamesData.has(String(value));
};

const requiredTrimmedString = (label: string) => yup
  .string()
  .transform((value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  })
  .trim()
  .required(`${label} is required`);
  
const optionalTrimmedString = () => yup
  .string()
  .transform((value) => {
    if (value === null || value === undefined) return '';
    return String(value);
  })
  .trim();

const gameSchema = (reportType: 'vending_sales' | 'vending_inventory') => {
  const base = optionalNumber()
    .test('game-exists', 'Game is not found in games list', function (value) {
      const context = (this.options as any)?.context;
      return validateGameExists(value, context);
    });

  return reportType === 'vending_inventory'
    ? base
    : base.required('Game is required');
};

const createLineSchema = (reportType: 'vending_sales' | 'vending_inventory') => yup
  .object()
  .shape({
    bin: reportType === 'vending_inventory'
      ? optionalNumber().required('Bin is required')
      : optionalNumber(),
    game: gameSchema(reportType),
    count: optionalNumber().min(0, 'Count must be 0 or more'),
    amount: optionalNumber(),
    quantity: optionalNumber().min(0, 'Quantity must be 0 or more'),
    value: optionalNumber(),
  });

export const createVendingSalesFormSchema = (
  reportType: 'vending_sales' | 'vending_inventory',
) => {
  return yup.object().shape({
    action: yup.string().required('Action is required'),
    confidence_score: yup
      .number()
      .min(0)
      .max(100)
      .required('Confidence score is required'),
    notes: yup.string(),
    location_key: requiredTrimmedString('Location'),
    shift_date: requiredTrimmedString('Date'),
    shift_start_time: reportType === 'vending_inventory'
      ? requiredTrimmedString('Time')
      : optionalTrimmedString(),
    parsed_data: yup.object().shape({
      final_json: yup.object().shape({
        retailer: requiredTrimmedString('Retailer'),
        terminal: optionalTrimmedString(),
        summary: yup.object().shape({
          draw_game_count: optionalNumber().min(0, 'Draw game count must be 0 or more'),
          draw_game_amount: optionalNumber(),
          scratcher_amount: optionalNumber(),
          total_amount: optionalNumber(),
        }),
        lines: yup
          .array()
          .of(
            createLineSchema(reportType),
          )
          .min(1, 'At least one line is required'),
      }),
    }),
  });
};

export const vendingSalesFormSchema = createVendingSalesFormSchema('vending_sales');
export const vendingInventoryFormSchema = createVendingSalesFormSchema('vending_inventory');
